module.exports = __webpack_public_path__ + "img/四川天府新区美地社区幼儿园.1d1b1561.jpg";